import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { token, user, role, loading } = useSelector((state) => state.auth);
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Check if user has required role
  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.type || role)) {
    const dashboardRoutes = {
      admin: '/admin/dashboard',
      organisation: '/organisation/dashboard',
      interpreter: '/interpreter/dashboard',
    };
    return <Navigate to={dashboardRoutes[user?.type || role] || '/auth/login'} replace />;
  }

  return children;

};
export default ProtectedRoute